
const Urun = resolve => {
    require.ensure(['../views/apps/urun/Urun'], () => {
        resolve(require('../views/apps/urun/Urun'))
    })
};
const UrunTanimlama = resolve => {
    require.ensure(['../views/apps/urun/UrunTanimla'], () => {
        resolve(require('../views/apps/urun/UrunTanimla'))
    })
};
const UrunListesi = resolve => {
    require.ensure(['../views/apps/urun/UrunListesi'], () => {
        resolve(require('../views/apps/urun/UrunListesi'))
    })
};
const UrunDuzenle = resolve => {
    require.ensure(['../views/apps/urun/UrunDuzenle'], () => {
        resolve(require('../views/apps/urun/UrunDuzenle'))
    })
};
const Kategori = resolve => {
    require.ensure(['../views/apps/urun/kategori/kategori'], () => {
        resolve(require('../views/apps/urun/kategori/kategori'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/urun/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/urun/kategori/KategoriTanimlama'))
    })
};
const KategoriListe = resolve => {
    require.ensure(['../views/apps/urun/kategori/KategoriListe'], () => {
        resolve(require('../views/apps/urun/kategori/KategoriListe'))
    })
};
const KategoriDuzenle = resolve => {
    require.ensure(['../views/apps/urun/kategori/KategoriDuzenle'], () => {
        resolve(require('../views/apps/urun/kategori/KategoriDuzenle'))
    })
};

const Opsiyon = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/Opsiyon'], () => {
        resolve(require('../views/apps/urun/opsiyon/Opsiyon'))
    })
};
const OpsiyonTanimlama = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/OpsiyonTanimla'], () => {
        resolve(require('../views/apps/urun/opsiyon/OpsiyonTanimla'))
    })
};
const OpsiyonListesi = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/OpsiyonListesi'], () => {
        resolve(require('../views/apps/urun/opsiyon/OpsiyonListesi'))
    })
};
const OpsiyonDuzenle = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/OpsiyonDuzenle'], () => {
        resolve(require('../views/apps/urun/opsiyon/OpsiyonDuzenle'))
    })
};

import layouts from '../layout'

export default {
    path: '/urun',
    name: 'urun',
    component: Urun,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'uruntanimlama',
            component: UrunTanimlama,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'liste',
            name: 'urunlistesi',
            component: UrunListesi,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'guncelleme',
            name: 'urunguncelle',
            component: UrunDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },{
            path: 'kategori',
            name: 'urunkategori',
            component: Kategori,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            },
            children: [
                {
                    path: 'tanimlama',
                    name: 'kategoritanimlama',
                    component: KategoriTanimlama,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        tags: ['app']
                    }
                },
                {
                    path: 'liste',
                    name: 'kategoriliste',
                    component: KategoriListe,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        tags: ['app']
                    }
                },
                {
                    path: 'guncelleme',
                    name: 'kategoriguncelleme',
                    component: KategoriDuzenle,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        tags: ['app']
                    }
                },
            ]
        },{
            path: 'opsiyon',
            name: 'urunopsiyon',
            component: Opsiyon,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            },
            children: [
                {
                    path: 'tanimlama',
                    name: 'opsiyontanimlama',
                    component: OpsiyonTanimlama,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        tags: ['app']
                    }
                },{
                    path: 'liste',
                    name: 'opsiyonliste',
                    component: OpsiyonListesi,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        tags: ['app']
                    }
                },{
                    path: 'guncelleme',
                    name: 'opsiyonguncelleme',
                    component: OpsiyonDuzenle,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        tags: ['app']
                    }
                },
            ]
        },

    ]
}
